(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-sort"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
  const currentParams = new URLSearchParams(window.location.search);
  currentParams.delete("sort_by");
  currentParams.delete("page");

  document.querySelectorAll(".sort-button[data-sort]").forEach(btn => {
    const params = new URLSearchParams(currentParams.toString());
    params.set("sort_by", btn.dataset.sort);
    btn.href = `${window.location.pathname}?${params.toString()}`;
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-toggle-button]').forEach(button => {
    button.addEventListener('click', () => {
      const container = button.closest('[data-facet-values]');
      const hiddenItems = container.querySelectorAll('.is-hidden');

      hiddenItems.forEach(el => el.classList.remove('is-hidden'));
      button.remove();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form-toasters"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
    const params = new URLSearchParams(window.location.search);
    if (params.get("customer_posted") === "true") {
      const popup = document.getElementById("newsletter-popup");
      popup.style.display = "flex";
      setTimeout(() => {
        popup.style.display = "none";
      }, 3000);
    }
    if (params.get("contact_posted") === "true") {
      const popup = document.getElementById("contact-popup");
      popup.style.display = "flex";
      setTimeout(() => {
        popup.style.display = "none";
      }, 3000);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["navigation-tree"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.nav-tree__toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        const parent = this.closest('.nav-tree__item');
        parent.classList.toggle('nav-tree__item--collapsed');
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
